import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import AllCarriersList from '@app/pages/customer/carriers/AllCarriersList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CarriersListPage = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`carriers.allCarriersList`, `Všichni dopravci`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_MY_CARRIERS_READ, PermissionTypesEnum.PERMISSION_MY_CARRIERS_RW]}>
      <AllCarriersList />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CarriersListPage);
